import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';

import { resolveCompanyVerificationStatusIcon, resolveMemberInitials } from '@core/tellent-util';
import type { ThemeName } from '@core/theme-util';
import {
  AvatarComponent,
  CompanyLogoComponent,
  ConnectedOverlayDirective,
  IconComponent,
  OverlayOriginDirective,
} from '@core/user-interface-legacy';

import { AdminProfileDropdownComponent } from './admin-profile-dropdown/admin-profile-dropdown.component';
import { injectTellentProfileDropdownConfig } from './tellent-profile-dropdown.config';

@Component({
  templateUrl: 'tellent-profile-dropdown.component.html',
  styleUrl: 'tellent-profile-dropdown.component.less',
  imports: [
    AvatarComponent,
    AdminProfileDropdownComponent,
    ConnectedOverlayDirective,
    OverlayOriginDirective,
    CompanyLogoComponent,
    IconComponent,
    NgTemplateOutlet,
  ],
  selector: 'tla-profile-dropdown',
})
export class TellentProfileDropdownComponent {
  public config = injectTellentProfileDropdownConfig();

  public companies = this.config.companies;
  public currentCompany = this.config.currentOrg;
  public currentMember = this.config.currentMember;
  public currentUser = this.config.currentUser;
  public companyVerificationStatus = this.config.companyVerificationStatus;
  public avatarThumbUrl = computed(() => this.currentUser()?.avatarThumbUrl);
  public logoThumbUrl = computed(() => this.currentCompany()!.logoThumbUrl);
  public hasThemeSwitcher = input<boolean>(false);
  public themeName = input<ThemeName>();
  public hasAmbassadorProgram = input<boolean>(false);
  public hasImpactTrackerInsights = input<boolean>(false);

  public themeChange = output<ThemeName>();

  public initials = computed(() => {
    const { firstName, lastName, email } = this.currentUser()!;
    return resolveMemberInitials({ firstName, lastName, email });
  });

  public verificationStatus = computed(() =>
    resolveCompanyVerificationStatusIcon(this.companyVerificationStatus()),
  );
}
